import {useAxios} from "@/utils/useAxios";

const api = {
    async getCommonCode(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/base/getCommCode")
        await execute(params);
        return data.value;
    },
    async getIncoTerms(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/base/getIncoTerms", {method: 'POST',}, {
            immediate: false,
            onSuccess: (response) => {
                data.value = response;
            },
        })
        await execute(params);
        return data;
    },
    async getBank(params) {
        const {data, execute} = await useAxios("/cmm/api/v2/base/getBank", {method: 'POST',}, {
            immediate: false,
            onSuccess: (response) => {
                data.value = response;
            },
        })
        await execute(params);
        return data;
    },

    // [003] 로그인 환경 실명인증
    async verifyMyName(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/verifyMyName", {method: 'POST',}, {
            exceptionThrow: true
        })
        await execute(params);
        return data;
    },

    // [003] SCI 실명인증
    async request(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/sci/name/request", {method: 'POST',}, {
            exceptionThrow: true,
            onSuccess: (response) => {
                data.value = response;
            },
        })
        await execute(params);
        return data;
    },

    // [076] 지급계좌조회
    async getMyBankAccnt(params) {
        const {data, execute} = await useAxios("/cmm/api/v3/usr/getMyBankAccnt", {method: 'POST',}, {
            immediate: false,
            onSuccess: (response) => {
                data.value = response;
            },
        })
        await execute(params);
        return data;
    },

    async setMyBankAccnt(params) {
        const {data, execute} = await useAxios("/cmm/api/v2/usr/setMyBankAccnt", {method: 'POST',}, {
            immediate: false,
            exceptionThrow: true,
            onSuccess: (response) => {
                data.value = response;
            }
        })
        await execute(params);
        return data;
    },

    async delMyBankAccnt(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/delMyBankAccnt", {method: 'POST',}, {
            immediate: false,
            onSuccess: (response) => {
                data.value = response;
            },
            onError: (error) => {

            }
        })
        await execute(params);
        return data;
    },
    // [059] 예금주 조회
    async getAccountHolder(params, claimType = "1", mpno) {
        let endpoint = "";

        // if (claimType === '1') {
        //     endpoint = "/cmm/api/v2/claim/getAccountHolder";
        // } else if (claimType === '2') {
        //     endpoint = "/cmm/api/v2/claim/getAccountHolder";
        // } else if (claimType === '3') {
        //     endpoint = "/cmm/api/v3/claim/getAccountHolder";
        // } else if (claimType === '4') {
        //     endpoint = "/cmm/api/v4/claim/getAccountHolder";
        // } else {
        //     endpoint = "/cmm/api/v1/claim/getAccountHolder";
        // }
        endpoint = "/cmm/api/v5/claim/getAccountHolder";

        const {data, execute} = await useAxios(endpoint, {method: 'POST',}, {
            immediate: false,
            exceptionThrow: true,
            onSuccess: (response) => {
                data.value = response;
            },
        })
        await execute(params);
        return data;
    },

    async getJuso(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/base/getJuso", {}, {
            exceptionThrow: true,
        });
        await execute(params);
        return data.value.result;
    },

    /* [113] 본인 생년월일 및 주민등록번호 저장 여부 조회 */
    async getMyIdentificationNo() {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getMyIdentificationNo");
        await execute();
        return data.value.result
    },

    /* [113] 대리인 생년월일 및 주민등록번호 저장 여부 조회 */
    async getDeputyIdentificationNo() {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getDeputyIdentificationNo");
        await execute();
        return data.value.result
    },

    /* 주민등록번호 검증 및 저장
    * 차후 검증/저장 분리시 처리필요
    *  */
    async setUserIdentificationNo(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/setUserIdentificationNo", {immediate: false,}, {
            exceptionThrow: true
        });
        await execute(params);
        return data.value.result
    },

    /* [119] 본인 주민등록번호 저장(retInfo)
     * /cmm/api/v1/usr/verifyMyName:[003]로그인 환경 실명인증 응답 retInfo 사용
     *
     * */
    async setMyIdentificationNo(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/setMyIdentificationNo", {}, {
            exceptionThrow: true
        });
        await execute(params);
        return data.value.result
    },

    /* [119] 대리인 주민등록번호 저장(retInfo)
    * * /cmm/api/v1/sci/request:[003]SCI 실명인증 응답 retInfo 사용
    *
    * */
    async setDeputyIdentificationNo(params) {
        const {data, execute} = await useAxios("/cmm/api/v2/claim/setDeputyIdentificationNo", {immediate: false,}, {
            exceptionThrow: true
        });
        await execute(params);
        return data.value.result
    },

    /* [125] APP PUSH 발송목록 조회 */
    async getSendPush() {
        const {data, execute} = await useAxios("/cmm/api/v1/msg/getSendPush", {immediate: false,}, {
            exceptionThrow: true
        });
        await execute();
        return data.value.result
    },

    /* [133] 약관조회 신규 */
    async getTermsNew(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/base/getTermsNew", {immediate: false,}, {
            exceptionThrow: true
        });
        await execute(params);
        return data.value.result
    },

    /*비밀번호 변경 제안 여부 확인*/
    async getPasswordChangeSuggest(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getPasswordChangeSuggest");
        await execute(params);
        return data.value.result
    },

    /*비밀번호 변경 제안 유예*/
    async setPasswordChangeDttmDeferred(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/setPasswordChangeDttmDeferred", {}, {
            exceptionThrow: true
        });
        await execute(params);
        return data.value
    },

    /* [142] 보험사/요양기관/은행 로고 다운로드 */
    async getInsttLogoDown(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/base/getInsttLogoDown", {immediate: false,}, {
            exceptionThrow: true
        });
        await execute(params);
        return data.value.result
    },

    /*팝업/배너 조회*/
    async getPopup(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/base/getPopup");
        await execute(params);
        return data.value.result
    },

    /*배너 이미지 다운로드*/
    async getBannerLogoDown(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/base/getBannerLogoDown");
        await execute(params);
        return data.value.result
    },

    // [999] 실손청구 첨부파일 악성코드 검사
    async setClaimFileCheck(params, type = 'claim') {
        // 실손청구: claim,
        // 내 보험사 등록: myInsu,
        // 자녀 등록: myChild
        let endpoint = "/cmm/api/v1/claim/setClaimFileCheck";
        switch (type) {
            case 'claim':
                endpoint = "/cmm/api/v1/claim/setClaimFileCheck";
                break;
            case 'myInsu':
                endpoint = "/cmm/api/v1/myInsu/setClaimFileCheck";
                break;
            case 'myChild':
                endpoint = "/cmm/api/v1/myChild/setClaimFileCheck";
                break;
        }

        const {data, execute} = await useAxios(endpoint,
            {
                method: 'POST'
            }, {

                loading: true,
                exceptionThrow: true,
            })
        await execute(params);
        return data;
    },

    //서버 현재시간 조회
    async getTokenTime() {
        const {data,execute} = await useAxios("/cmm/api/v1/member/getTokenTime")
        await execute();
        return data.value.result
    }
}

export default api;
